<p-carousel
  class="block -mx-4"
  [value]="carouselData()"
  [numVisible]="1"
  [numScroll]="1"
  [page]="0"
  [showIndicators]="false"
>
  <ng-template let-review pTemplate="item">
    <div class="{{review.color}} px-5 h-full py-8 rounded-xl flex flex-col mx-1 items-center">
      <img [src]="review.photo" alt="Photo of {{review.name}}" class="rounded-full size-[6rem]" />
      <p class="text-2xl mt-4 text-white">{{review.name}}</p>
      <p class="mt-8 text-sm tracking-wider leading-6 text-white text-center">"{{review.review}}"</p>
      @if (articleLinksEnabled() && review.articleSlug) {
        <a
          pButton
          [dt]="whiteButtonDt"
          class="mt-8 inline-flex items-center gap-2 px-4 py-2 font-medium"
          [routerLink]="['/articles', review.articleSlug]"
        >
          Read {{ review.storyPronoun || 'their' }} story
        </a>
      }
    </div>
  </ng-template>
</p-carousel>
